// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-containers-___Application__button___uF5gu {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.src-styles-containers-___Application__button___uF5gu.src-styles-containers-___Application__success___rMDFJ {
  background-color: #4ca92f;
  color: #ffffff;
}
.src-styles-containers-___Application__button___uF5gu.src-styles-containers-___Application__success___rMDFJ:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.src-styles-containers-___Application__button___uF5gu.src-styles-containers-___Application__alert___xNMte {
  background-color: #ff401e;
  color: #ffffff;
}
.src-styles-containers-___Application__button___uF5gu.src-styles-containers-___Application__alert___xNMte:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.src-styles-containers-___Application__button___uF5gu:disabled,
.src-styles-containers-___Application__button___uF5gu:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___Application__inputField___IuRw1 {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
* {
  box-sizing: border-box;
}
body {
  background-color: #ffffff;
  font-family: FreeSans, Arimo, "Droid Sans", Helvetica, Arial, sans-serif;
  font-size: 16px;
  margin: 0;
  padding: 0;
}
.src-styles-containers-___Application__content___LOhEk {
  padding: 0;
}
a {
  color: #4ca92f;
  text-decoration: none;
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
a:hover {
  color: #3a8124;
}
.button {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.button.success {
  background-color: #4ca92f;
  color: #ffffff;
}
.button.success:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.button.alert {
  background-color: #ff401e;
  color: #ffffff;
}
.button.alert:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.button:disabled, .button:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.button .fa {
  margin-right: 0.25em;
}
.button + .button {
  margin-left: 0.5em;
}
#a0-lock.a0-theme-default .a0-panel .a0-icon-container .a0-image img {
  height: auto;
}
#a0-lock.a0-theme-default .a0-panel .a0-mode form .a0-body-content {
  padding: 10px;
}
#a0-lock.a0-theme-default .a0-panel button.a0-primary {
  background-color: #4ca92f !important;
}
#a0-lock.a0-theme-default .a0-panel button.a0-primary:hover {
  background-color: #3a8124 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less","webpack://./src/styles/containers/Application.less"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;ACDF;ADGE;EACE,yBAAA;EACA,cAAA;ACDJ;ADGI;EACE,yBAAA;EACA,cAAA;ACDN;ADKE;EACE,yBAAA;EACA,cAAA;ACHJ;ADKI;EACE,yBAAA;EACA,cAAA;ACHN;ADOE;;EACE,0CAAA;ACJJ;ADQA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACNF;AAlCA;EACE,sBAAA;AAoCF;AAjCA;EACE,yBAAA;EACA,wEAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAmCF;AAhCA;EACE,UAAA;AAkCF;AA/BA;EACE,cAAA;EACA,qBAAA;EACA,oDAAA;AAiCF;AA/BE;EACE,cAAA;AAiCJ;AA7BA;ED1BE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;AC0DF;ADxDE;EACE,yBAAA;EACA,cAAA;AC0DJ;ADxDI;EACE,yBAAA;EACA,cAAA;AC0DN;ADtDE;EACE,yBAAA;EACA,cAAA;ACwDJ;ADtDI;EACE,yBAAA;EACA,cAAA;ACwDN;ADpDE;EACE,0CAAA;ACuDJ;AA3DA;EAKM,oBAAA;AAyDN;AA9DA;EAUI,kBAAA;AAuDJ;AAjEA;EAeI,YAAA;AAqDJ;AApEA;EAmBI,aAAA;AAoDJ;AAvEA;EAuBI,oCAAA;AAmDJ;AAjDI;EACE,oCAAA;AAmDN","sourcesContent":["@import './variables.less';\n\n.button {\n  background-color: transparent;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  color: @color-main-white;\n  padding: 0.75em 1em;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  transition: @transition;\n  \n  &.success {\n    background-color: @color-main-green;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &.alert {\n    background-color: @color-main-red;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-red, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &:disabled, &:disabled:hover {\n    background-color: @color-main-gray;\n  }\n}\n\n.inputField {\n  font-size: 1.5em;\n  border: 1px solid @color-main-gray;\n  border-radius: 3px;\n  padding: 0.2em;\n  min-width: 300px;\n  width: 100%;\n}\n","@import '../variables.less';\n@import '../mixins.less';\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: @color-main-white;\n  font-family: FreeSans, Arimo, \"Droid Sans\", Helvetica,Arial, sans-serif;\n  font-size: @font-size;\n  margin: 0;\n  padding: 0;\n}\n\n.content {\n  padding: 0;\n}\n\na {\n  color: @color-main-green;\n  text-decoration: none;\n  transition: @transition;\n\n  &:hover {\n    color: darken(@color-main-green, 10%);\n  }\n}\n\n:global {\n  .button {\n    .button();\n\n    .fa {\n      margin-right: 0.25em;\n    }\n  }\n\n  .button + .button {\n    margin-left: 0.5em;\n  }\n\n  // Auth0 lock\n  #a0-lock.a0-theme-default .a0-panel .a0-icon-container .a0-image img {\n    height: auto;\n  }\n\n  #a0-lock.a0-theme-default .a0-panel .a0-mode form .a0-body-content {\n    padding: 10px;\n  }\n\n  #a0-lock.a0-theme-default .a0-panel button.a0-primary {\n    background-color: @color-main-green !important;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var button = `src-styles-containers-___Application__button___uF5gu`;
export var success = `src-styles-containers-___Application__success___rMDFJ`;
export var alert = `src-styles-containers-___Application__alert___xNMte`;
export var inputField = `src-styles-containers-___Application__inputField___IuRw1`;
export var content = `src-styles-containers-___Application__content___LOhEk`;
export default ___CSS_LOADER_EXPORT___;
